import React, { useState } from 'react';
import { Box, Input, InputGroup, InputLeftElement, Flex, Text, Grid, Badge } from '@chakra-ui/react';
import { Search, Shirt, SlidersHorizontal } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { ProductCard } from '../components/ProductCard';
import { categories } from '../data/mockData';
export const Products: React.FC = () => {
  const {
    products
  } = useAppContext();
  const {
    category: urlCategory
  } = useParams<{
    category?: string;
  }>();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(urlCategory || 'All');
  const filteredProducts = products.filter(product => {
    const matchesSearch = product.title.toLowerCase().includes(searchQuery.toLowerCase()) || product.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'All' || product.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });
  return <Box bg="gray.50" minH="100%" className="animate-fade-in" data-id="element-619">
      {/* Search Bar */}
      <Box px={4} pt={4} pb={2} bg="white" data-id="element-620">
        <InputGroup data-id="element-621">
          <InputLeftElement pointerEvents="none" h="44px" data-id="element-622">
            <Search color="#9CA3AF" size={18} data-id="element-623" />
          </InputLeftElement>
          <Input type="text" placeholder="Search clothing..." bg="gray.50" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} borderRadius="12px" border="none" h="44px" fontSize="sm" _focus={{
          bg: 'gray.100',
          boxShadow: 'none'
        }} data-id="element-624" />
        </InputGroup>
      </Box>

      {/* Category Filter */}
      <Box bg="white" pb={3} px={4} data-id="element-625">
        <Flex overflowX="auto" gap={2} pb={1} sx={{
        '&::-webkit-scrollbar': {
          display: 'none'
        }
      }} data-id="element-626">
          {categories.map(cat => <Badge key={cat} px={4} py={2} borderRadius="full" cursor="pointer" bg={selectedCategory === cat ? 'brand.500' : 'gray.100'} color={selectedCategory === cat ? 'white' : 'gray.600'} onClick={() => setSelectedCategory(cat)} whiteSpace="nowrap" fontWeight="600" fontSize="xs" transition="all 0.2s ease" _hover={{
          transform: 'scale(1.05)'
        }} data-id="element-627">
              {cat}
            </Badge>)}
        </Flex>
      </Box>

      <Box px={4} pt={4} data-id="element-628">
        {products.length === 0 ? <Flex direction="column" align="center" justify="center" py={16} px={4} textAlign="center" className="animate-slide-up" data-id="element-629">
            <Box className="animate-float" mb={5} data-id="element-630">
              <Box bg="brand.50" p={6} borderRadius="full" data-id="element-631">
                <Shirt size={56} color="var(--chakra-colors-brand-500)" data-id="element-632" />
              </Box>
            </Box>
            <Text fontSize="xl" fontWeight="700" color="gray.800" mb={2} data-id="element-633">
              Products Coming Soon 👕
            </Text>
            <Text color="gray.500" fontSize="sm" maxW="280px" lineHeight="1.6" data-id="element-634">
              Sky Brand is preparing something stylish for you.
            </Text>
          </Flex> : <>
            <Flex justify="space-between" align="center" mb={3} data-id="element-635">
              <Text fontSize="xs" color="gray.400" fontWeight="500" data-id="element-636">
                {filteredProducts.length} products
              </Text>
              <Flex align="center" gap={1} color="gray.400" cursor="pointer" data-id="element-637">
                <SlidersHorizontal size={14} data-id="element-638" />
                <Text fontSize="xs" fontWeight="500" data-id="element-639">
                  Filter
                </Text>
              </Flex>
            </Flex>

            {filteredProducts.length > 0 ? <Grid templateColumns="repeat(2, 1fr)" gap={3} pb={4} data-id="element-640">
                {filteredProducts.map((product, idx) => <ProductCard key={product.id} product={product} index={idx} data-id="element-641" />)}
              </Grid> : <Flex direction="column" align="center" justify="center" py={10} data-id="element-642">
                <Search size={40} color="var(--chakra-colors-gray-300)" data-id="element-643" />
                <Text mt={4} color="gray.400" fontSize="sm" data-id="element-644">
                  No products found
                </Text>
              </Flex>}
          </>}
      </Box>
    </Box>;
};